<template>
  <div class="spl-general-footer">
    <form-button
      v-if="cancelVisible"
      :extrapadding="true"
      :secondary="true"
      :disabled="disableNegative"
      @onClick="cancelClicked">
      {{ negativeLabel }}
    </form-button>
    <form-button
      :extrapadding="true"
      :disabled="disablePositive"
      @onClick="positiveClicked">
      {{ positiveLabel }}
    </form-button>
  </div>
</template>

<script>
export default {
  name: 'GeneralFooter',
  props: {
    positiveLabel: {
      type: String,
      default: 'Save'
    },
    negativeLabel: {
      type: String,
      default: 'Cancel'
    },
    cancelVisible: {
      type: Boolean,
      default: false
    },
    disablePositive: {
      type: Boolean,
      default: false
    },
    disableNegative: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    cancelClicked () {
      this.$emit('negativeClicked')
    },
    positiveClicked () {
      this.$emit('positiveClicked')
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";

.spl-general-footer {
  background-color: $middleYellow;
  border-top: 3px solid #fff;
  padding: 20px $mainPadding 4px $mainPadding;
  width: 100%;
  position: fixed;
  bottom: 0px;
  margin-left: -70px;
  .spl-button {
    background-color: $mainInputColor;
    color: $footerButtonDarkGreyText;
    float: right;
    &:focus,
    &:not([disabled]):hover {
      background-color: #fff;
      color: $yellowButtonLabelHover;
    }
    &-secondary {
      background-color: $footerButtonYellow;
      color: $yellowButtonLabel;
    }
  }
}
@include mobile {
  .spl-general-footer {
    padding: 0px;
    margin: 0 0 0 -10px;
    display: flex;

    & .spl-button {
      flex-grow: 1;
      float: none;
      margin: 10px 0 10px 10px;
    }

    & .spl-button:last-child {
      margin-right: 10px;
    }
  }
}
</style>
